/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React, { useRef, useState } from "react";

import styled from "styled-components";

import { borderControl } from "src/components/UI/Menus/utils";
import useIsomorphicLayoutEffect from "src/lib/hooks/useIsomorphicLayoutEffect";
import { CSSPositionOffsets } from "src/lib/types";

interface Props {
  children: React.ReactNode | React.ReactNode[];
}

export const BorderControl = ({ children }: Props) => {
  const ref = useRef<HTMLDivElement>(null);
  const [position, setPosition] = useState<CSSPositionOffsets>({});
  const [reversed, setReversed] = useState<boolean>(false);

  useIsomorphicLayoutEffect(() => {
    if (!ref.current || !ref.current.parentElement) return;
    const anchor = ref.current.parentElement.getBoundingClientRect();
    const dimensions = ref.current.getBoundingClientRect();

    const { shouldReverse, menuPosition } = borderControl({ anchor, dimensions, reversed });

    setReversed(shouldReverse);
    setPosition(menuPosition);
  }, []);

  return (
    <StyledWrapper ref={ref} style={{ ...position }}>
      {children}
    </StyledWrapper>
  );
};

const StyledWrapper = styled.div`
  position: fixed;
`;
